import { LinesLoader } from "components/common/tools/Spinner";

function ActivityLoader() {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <LinesLoader />
    </div>
  );
}

export default ActivityLoader;
